import { randomCave } from './RandomCave.js'
import { randomDungeon } from './RandomDungeon.js'
import { randomSimplexMap } from './RandomSimplex.js'

export default {
	randomCave,
	randomDungeon,
	randomSimplexMap
}
